// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5 {
  font-size: 13px;
}

h3 span {
  color: #999999;
  font-size: 13px;
  font-weight: 600;
  font-style: italic;
  margin: 0px 5px;
}
h3 .blue {
  color: #22b7ff;
  margin-right: 2px;
}

.m-0 {
  margin: 0px;
}

.password-streight {
  padding-top: 40px;
}
.password-streight div {
  margin-bottom: 7.5px;
  padding-left: 50px;
  color: #cccccc;
}
.password-streight div:first-child {
  font-weight: 800;
  color: #999999;
}
.password-streight .success {
  margin-right: 10px;
  margin-top: 7px;
  width: 5px;
  height: 5px;
  float: left;
  border-radius: 50%;
  background-color: #22b7ff;
}
.password-streight .fail {
  width: 5px;
  height: 5px;
  margin-right: 10px;
  color: #e57373;
  float: left;
}

.container-card-config {
  margin-bottom: 50px;
}

.p-0 {
  padding: 0px;
}

.show-password {
  margin-top: 20px;
}
.show-password span {
  margin-left: 5px;
}

.msg-error {
  color: #e57373;
}

.msg-success {
  color: #22b7ff;
}

#image-crop {
  width: 100%;
}

.send-image button {
  margin-top: 20px;
}

.msg-zero-rows {
  height: 185px;
  line-height: 185px;
}
.msg-zero-rows span {
  display: inline-block;
  width: 100%;
  text-align: center;
  color: #cccccc;
}

@media (max-width: 767px) {
  .info-geral {
    text-align: center;
    margin: 30px 0;
  }
  .pull-right {
    width: 100%;
  }
  .password-streight {
    padding-top: 0;
    margin-bottom: 30px;
  }
  .password-streight div {
    padding-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/minha-conta/configuracoes/configuracoes.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,eAAA;AAAJ;;AAII;EACI,cCWI;EDVJ,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AADR;AAGI;EACI,cCNG;EDOH,iBAAA;AADR;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;AAGI;EACI,oBAAA;EACA,kBAAA;EACA,cCTI;ADQZ;AAEQ;EACI,gBAAA;EACA,cCbA;ADaZ;AAGI;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBCjCG;ADgCX;AAGI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cCbC;EDcD,WAAA;AADR;;AAKA;EACI,mBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;AAGI;EACI,gBAAA;AADR;;AAKA;EACI,cClCK;ADgCT;;AAKA;EACI,cChEO;AD8DX;;AAKA;EACI,WAAA;AAFJ;;AAMI;EACI,gBAAA;AAHR;;AAOA;EACI,aAAA;EACA,kBAAA;AAJJ;AAMI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,cC1EI;ADsEZ;;AAQA;EACI;IACI,kBAAA;IACA,cAAA;EALN;EAQE;IACI,WAAA;EANN;EASE;IACI,cAAA;IACA,mBAAA;EAPN;EASM;IACI,eAAA;EAPV;AACF","sourcesContent":["@import '../../../../../../sass/variables';\nh5 {\n    font-size: 13px;\n}\n\nh3 {\n    span {\n        color: $cinza-500;\n        font-size: 13px;\n        font-weight: 600;\n        font-style: italic;\n        margin: 0px 5px;\n    }\n    .blue {\n        color: $azul-400;\n        margin-right: 2px;\n    }\n}\n\n.m-0 {\n    margin: 0px;\n}\n\n.password-streight {\n    padding-top: 40px;\n    div {\n        margin-bottom: 7.5px;\n        padding-left: 50px;\n        color: $cinza-400;\n        &:first-child {\n            font-weight: 800;\n            color: $cinza-500;\n        }\n    }\n    .success {\n        margin-right: 10px;\n        margin-top: 7px;\n        width: 5px;\n        height: 5px;\n        float: left;\n        border-radius: 50%;\n        background-color: $azul-400;\n    }\n    .fail {\n        width: 5px;\n        height: 5px;\n        margin-right: 10px;\n        color: $danger;\n        float: left;\n    }\n}\n\n.container-card-config {\n    margin-bottom: 50px;\n}\n\n.p-0 {\n    padding: 0px;\n}\n\n.show-password {\n    margin-top: 20px;\n    span {\n        margin-left: 5px;\n    }\n}\n\n.msg-error {\n    color: $danger;\n}\n\n.msg-success {\n    color: $azul-400;\n}\n\n#image-crop {\n    width: 100%;\n}\n\n.send-image {\n    button {\n        margin-top: 20px;\n    }\n}\n\n.msg-zero-rows {\n    height: 185px;\n    line-height: 185px;\n\n    span {\n        display: inline-block;\n        width: 100%;\n        text-align: center;\n        color: $cinza-400;\n    }\n}\n\n@media (max-width: 767px) {\n    .info-geral {\n        text-align: center;\n        margin: 30px 0;\n    }\n\n    .pull-right {\n        width: 100%;\n    }\n\n    .password-streight {\n        padding-top: 0;\n        margin-bottom: 30px;\n\n        div {\n            padding-left: 0;\n        }\n    }\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
